import React from 'react';
import { ProductDetailSelection, SimpleSelectionDto } from './types';
import ProductSelectionsList from '../shopping-cart/ProductSelectionsList';

interface ProductAttributeListprops {
	selections?: ProductDetailSelection[];
}

/**
 * Renders a product selectable attributes
 */
export default function ProductSelectableAttributesList(props: ProductAttributeListprops) {
	const { selections } = props;

	if (!selections) {
		return null;
	}

	const simpleSelections = selections
		.filter((s) => s.values?.length > 0)
		.map<SimpleSelectionDto>((selection) => ({
			name: selection.label,
			id: selection.values[0].value,
			label: selection.values[0].label,
			value: selection.values[0].label,
			field: selection.field,
		}));

	return <ProductSelectionsList selections={simpleSelections} classNamePrefix="roc-order-details-item" />;
}
